module.exports = __webpack_public_path__ + "img/car-3-svgrepo-com.b56d8438.svg";